import ic_close from "../../assets/icons/ic_close.svg";
import { Dialog } from "@headlessui/react";
import CustomDialog from "../basic/Dialog";
import IconButton from "../basic/IconButton";
import { WhiteLinearGradient } from "../../utils/Utils";
import ic_tick from "../../assets/icons/ic_green_grad_tick.svg";
import Button from "../basic/Button";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";

function PaymentSuccessDialog({ subscription, show, close }) {
  const navigate = useNavigate();
  return (
    <CustomDialog show={show} close={close} closeWhenClickedOutside={false}>
      <Dialog.Panel>
        <div
          className={`flex flex-col max-w-6xl ${WhiteLinearGradient} rounded-xl w-full `}
        >
          <div
            className={`flex w-full justify-center items-center flex-col rounded-xl bg-primary-white p-5`}
          >
            <div className="w-full flex justify-end items-end">
              <IconButton
                icon={ic_close}
                className="shadow-xl flex justify-end"
                onClick={() => {
                  // navigate("/exercise");
                  navigate("/programpage");
                }}
              />
            </div>
            <Icon
              icon="charm:circle-tick"
              className="h-16 w-16 text-primary-blue"
            />
            <p className="text-xl">Payment Successfull</p>
            <p className="text-2xl">Thank you for your purchase</p>
          </div>

          <div className="flex flex-col items-start  p-10">
            <p className=" text-primary-lightBlack text-xl">
              Your Plan Includes
            </p>
            {subscription.details.map((detail, index) => {
              return (
                <div className="flex flex-row py-1 items-start" key={index}>
                  <img src={ic_tick} className="mt-1" />
                  <p className="ml-3 text-primary-gray dark:text-primary-white">
                    {detail}
                  </p>
                </div>
              );
            })}
          </div>
          <Button
            type="primary"
            className={"mt-10 max-w-max self-end m-5"}
            onClick={() => {
              navigate("/practice");
            }}
          >
            Get Started
          </Button>
        </div>
      </Dialog.Panel>
    </CustomDialog>
  );
}

export default PaymentSuccessDialog;
